
// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';

// init Swiper:
const swiper = new Swiper('.js_shop_bar_slider', {
  // configure Swiper to use modules
  modules: [Autoplay],

  loop: true,
  grabCursor: true,
  draggable: true,
  slidesPerView: 2,
  spaceBetween: 10,

  // lazy: {
  //   loadPrevNext: true,
  //   loadPrevNextAmount: 1,
  // },

  autoplay: {
    delay: 4000,
    disableOnInteraction: false
  },

  breakpoints: {
    // when window width is >= 
    650: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1000: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    1300: {
      slidesPerView: 5,
      spaceBetween: 40,
    },
  },

  on: {
    init: function () {
      var testSlider = document.querySelectorAll('.js_shop_bar_slider');
      for (var i = 0; i < testSlider.length; i++) {
        testSlider[i].classList.add('opacity-100');
        testSlider[i].classList.add('h-auto');
        testSlider[i].classList.remove('opacity-0');
        testSlider[i].classList.remove('h-0');
      }
    },
  },
});